import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

const PlaylistsCheckbox = ({ playlist, checked, onChange }) => {
  const [isChecked, setIsChecked] = useState(checked);

  const handleChange = (e) => {
      const value = e.target.value;
      onChange(value, !isChecked);
      setIsChecked(!isChecked);
  }

  return(
      <Form.Group controlId={ 'playlistCheckbox' + playlist.id }>
        <Form.Check type="checkbox" label={ playlist.name }
                    checked={ isChecked }
                    value={ playlist.id }
                    onChange={ handleChange } />
      </Form.Group>
  )
}

PlaylistsCheckbox.propTypes = {
  playlist: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default PlaylistsCheckbox;
